import { useState, useEffect, useRef } from "react";

/* ─────────────────────────────────────────────
   IMAGE IMPORTS — src/assets/images/team/
───────────────────────────────────────────── */
import HeroBg         from "../../assets/images/team/team-hero-bg.webp";
import HeroBgMobile   from "../../assets/images/team/team-hero-bg-mobile.webp";
import RavinImg       from "../../assets/images/team/ravin-mirchandani.webp";
import RavinHoverImg  from "../../assets/images/team/ravin-mirchandani-hover.webp";
import RituImg        from "../../assets/images/team/ritu-david.webp";
import RituHoverImg   from "../../assets/images/team/ritu-david-hover.webp";
import AdityaImg      from "../../assets/images/team/aditya-sharma.webp";
import AdityaHoverImg from "../../assets/images/team/aditya-sharma-hover.webp";
import SunilImg       from "../../assets/images/team/sunil-bhambani.webp";
import SunilHoverImg  from "../../assets/images/team/sunil-bhambani-hover.webp";
import SwanandImg     from "../../assets/images/team/swanand-deshpande.webp";
import SwanandHoverImg from "../../assets/images/team/swanand-deshpande-hover.webp";

/* ─────────────────────────────────────────────
   ICON IMPORTS — src/assets/icons/team/
───────────────────────────────────────────── */
import IconLinkedIn   from "../../assets/icons/team/linkedin.svg";

/* ─────────────────────────────────────────────
   TeamPage.jsx
   Prefix  : tm-
   Font    : Montserrat (headings) | Roboto (body)
   Purple  : #743FAC
   BG      : #1A1A1A  |  Dark: #111111
   Max-W   : 1600px   |  Pad: 102px
   Breaks  : 768px    |  480px
   Hover   : image scale + purple glow
   Layout  : alternating photo-left / photo-right
─────────────────────────────────────────────── */

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&family=Roboto:wght@300;400;500;700&display=swap');

  .tm-wrap *, .tm-wrap *::before, .tm-wrap *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  .tm-wrap {
    font-family: 'Montserrat', sans-serif;
    background: #1A1A1A;
    color: #ffffff;
    width: 100%;
    overflow-x: hidden;
  }
  .tm-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 221px;
    padding-right: 221px;
    width: 100%;
  }

  /* ── SCROLL FADE-UP ── */
  .tm-fade-up {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .tm-fade-up.tm-in {
    opacity: 1;
    transform: translateY(0);
  }
  .tm-delay-1 { transition-delay: 0.08s; }
  .tm-delay-2 { transition-delay: 0.18s; }
  .tm-delay-3 { transition-delay: 0.28s; }

  /* ══════════════════════════════════════
     SECTION 1 — HERO BANNER
  ══════════════════════════════════════ */
  .tm-hero {
    width: 100%;
    position: relative;
    overflow: hidden;
    height: 400px;
    display: flex;
    align-items: center;
  }
  .tm-hero__bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    z-index: 0;
  }
  .tm-hero__overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      110deg,
      rgba(5,8,30,0.88) 0%,
      rgba(15,10,50,0.75) 40%,
      rgba(60,20,100,0.45) 70%,
      rgba(100,30,140,0.2) 100%
    );
    z-index: 1;
  }
  .tm-hero__content {
    position: relative;
    z-index: 2;
    padding-bottom: 0;
  }
  .tm-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    line-height: 1.1;
  }

  /* ══════════════════════════════════════
     SECTION 2 — TEAM MEMBERS
  ══════════════════════════════════════ */
  .tm-section {
    width: 100%;
    background: #1A1A1A;
    padding: 100px 0 80px 0;
    border-bottom: 1px solid #4A4A4A;
  
  }
    .tm-section:last-child {border:none} 
  .tm-section--dark {
    // background: #111111;
  }

  /* Section label — "Our Producer" */
  .tm-section__label {
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    text-align: center;
    margin-bottom: 80px;
  }

  /* ── MEMBER ROW ── */
  .tm-member {
    display: flex;
    align-items: center;
    gap: 100px;
    padding: 0px 29px 60px 29px;
    // border-bottom: 1px solid rgba(255,255,255,0.07);
  }
    .tm-member: last-child {  border-bottom:1px solid #4A4A4A;}
    
  .tm-member:first-of-type {
    padding-top: 0;
  }
  .tm-member:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }

  /* photo on right for even rows */
  .tm-member--reverse {
    flex-direction: row-reverse;
  }

  /* ── PHOTO CARD ── */
  .tm-photo-wrap {
    flex-shrink: 0;
    width: 400px;
    height: 481px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
   
  }
  /* purple watercolor bg behind photo */
  .tm-photo-wrap::before {
    content: '';
    position: absolute;
    inset: 0;
    // background: #743FAC;
    border-radius: 10px;
    z-index: 0;
  }
  .tm-photo-wrap img {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    border-radius: 10px;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
                filter 0.4s ease,
                box-shadow 0.4s ease,
                opacity 0.3s ease;
    display: block;
  }
  /* HOVER EFFECT — scale + purple glow */
   .tm-photo-wrap:hover img {    
    // transform: scale(1.06);
    filter: brightness(1.08) saturate(1.1);
    border:1px solid #ffffff;
    
  }

  /* ── TEXT COL ── */
  .tm-member__info {
    flex: 1;
    min-width: 0;
  }
  .tm-member__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 14px;
    line-height: 120%;
  }
  .tm-member__role {
    font-family: 'Roboto', sans-serif;
    font-size: 20px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 14px;
  }
  .tm-member__bio {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 160%;
    color: #FFFFFF;
    margin-bottom: 44px;
    max-width: 480px;
  }

  /* ── LINKEDIN BUTTON ── */
  .tm-linkedin {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    
    border-radius: 8px;
    text-decoration: none;
    transition: opacity 0.2s, transform 0.2s;
    flex-shrink: 0;
  }
  .tm-linkedin:hover {
    opacity: 0.85;
    transform: translateY(-2px);
  }
  .tm-linkedin svg {
    width: 44px;
    height: 44px;
    object-fit: contain;
    // filter: brightness(0) invert(1);
    display: block;
  }

  /* ══════════════════════════════════════
     RESPONSIVE 768px
  ══════════════════════════════════════ */
  @media (max-width: 768px) {
    .tm-inner { padding-left: 32px; padding-right: 32px; }
    .tm-hero { height: 350px; }
    .tm-hero__title { font-size: 32px; }
    .tm-hero__bg { object-position: right;}
    .tm-section { padding: 48px 0 0px 0; }
    .tm-section__label { font-size: 32px; margin-bottom: 24px; }
    .tm-member {
      flex-direction: row;
      gap: 32px;
      padding: 48px 0 0px 0px;
    }
      
      
    .tm-member--reverse { flex-direction: row-reverse; }
    .tm-photo-wrap { width: 220px; height: 270px; }
    .tm-member__name { font-size: 22px; ; }
    .tm-member__role { }
    .tm-member__bio { max-width: 100%;  margin-bottom: 24px;}
    .tm-linkedin svg { justify-content:center; align-items:center; padding-left:40px; }
  }

  /* ══════════════════════════════════════
     RESPONSIVE 480px
  ══════════════════════════════════════ */
  @media (max-width: 480px) {
    .tm-inner { padding-left: 16px; padding-right: 16px; }
    .tm-hero {height:282px}
    .tm-member { flex-direction: column;gap: 15px; padding: 30px 0 0px 0px;}
   
    
        
    .tm-hero__overlay { background:none; align-items: start;}
    .tm-hero__title { font-size: 24px; }
        .tm-section{padding: 60px 0 60px 0; border-bottom: 1px solid #4A4A4A;}
        .tm-section:last-child {border:none} 
    .tm-section__label { font-size: 24px; }
    .tm-photo-wrap { width: 100%; height: 408px; }
   
    .tm-member__name { font-size: 20px; }
    .tm-member__role { font-size: 16px; }
    .tm-member__bio { font-size: 14px;margin-bottom: 14px; }
  }
`;

/* ─── DATA ─────────────────────────────────── */

const TEAM = [
  {
    name: "Ravin MIRCHANDANI",
    role: "Executive director & the Host",
    bio: "Ravin is storyteller of energy and innovation, having worked in this sector in 6 countries. With a rare mix of warmth and audacity, he bridges boardrooms and shop floors, turning bold ideas into movements that people believe in.",
    linkedin: "https://www.linkedin.com/in/ravinmirchandani/",
    img: RavinImg,
    hoverImg: RavinHoverImg,
    reverse: false,
  },
  {
    name: "Ritu DAVID",
    role: "Co-Host",
    bio: "Ritu aligns strategy with execution, ensuring every initiative delivers measurable value, operational excellence, and people-first leadership.",
    linkedin: "https://www.linkedin.com/in/ritudavid/",
    img: RituImg,
    hoverImg: RituHoverImg,
    reverse: true,
  },
  {
    name: "Aditya SHARMA",
    role: "Head of Production",
    bio: "Aditya transforms stories into crafted experiences, blending design, editing, and storytelling to give every episode clarity, creativity, and polish.",
    linkedin: "https://www.linkedin.com/in/adityasharma/",
    img: AdityaImg,
    hoverImg: AdityaHoverImg,
    reverse: false,
  },
];

const PRODUCERS = [
  {
    name: "Sunil BHAMBANI",
    role: "Executive Producer",
    bio: "Sunil brings structure and sharp execution to every episode. With his eye for detail and instinct for quality, he ensures the podcast runs with precision, trust, and polish.",
    linkedin: "https://www.linkedin.com/in/sunilbhambani/",
    img: SunilImg,
    hoverImg: SunilHoverImg,
    reverse: false,
  },
  {
    name: "Swanand DESHPANDE",
    role: "Producer",
    bio: "Swanand fuels the show with strategy and creativity, shaping conversations that break boundaries and deliver lasting impact for listeners everywhere.",
    linkedin: "https://www.linkedin.com/in/swananddeshpande/",
    img: SwanandImg,
    hoverImg: SwanandHoverImg,
    reverse: true,
  },
];

/* ─── SCROLL REVEAL ─────────────────────────── */
function useScrollReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".tm-fade-up");
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add("tm-in"); }),
      { threshold: 0.12 }
    );
    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);
}

/* ─── MEMBER CARD ───────────────────────────── */
function MemberCard({ member }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div className={`tm-member tm-fade-up${member.reverse ? " tm-member--reverse" : ""}`}>
      {/* PHOTO */}
      <div
        className="tm-photo-wrap"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <img
          src={hovered ? member.hoverImg : member.img}
          alt={member.name}
        />
      </div>

      {/* INFO */}
      <div className="tm-member__info">
        <h2 className="tm-member__name">{member.name}</h2>
        <p className="tm-member__role">{member.role}</p>
        <p className="tm-member__bio">{member.bio}</p>
        <a
          href={member.linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="tm-linkedin"
          aria-label={`${member.name} LinkedIn`}
        >
          <img src={IconLinkedIn} alt="LinkedIn" />
        </a>
      </div>
    </div>
  );
}

/* ─── HERO ──────────────────────────────────── */
function HeroSection() {
  const [isMobile, setIsMobile] = useState(false);
 
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    setIsMobile(mq.matches);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
 
  return (
    <section className="tm-hero">
      <img
        className="tm-hero__bg"
        src={isMobile ? HeroBgMobile : HeroBg}
        alt=""
        aria-hidden="true"
      />
      <div className="tm-hero__overlay" />
      <div className="tm-inner tm-hero__content">
        <h1 className="tm-hero__title">Our Team</h1>
      </div>
    </section>
  );
}

/* ─── TEAM SECTION ──────────────────────────── */
function TeamSection() {
  return (
    <section className="tm-section">
      <div className="tm-inner">
        {TEAM.map((m, i) => (
          <MemberCard key={i} member={m} />
        ))}
      </div>
    </section>
  );
}

/* ─── PRODUCER SECTION ──────────────────────── */
function ProducerSection() {
  return (
    <section className="tm-section tm-section--dark">
      <div className="tm-inner">
        <h2 className="tm-section__label tm-fade-up">Our Producer</h2>
        {PRODUCERS.map((m, i) => (
          <MemberCard key={i} member={m} />
        ))}
      </div>
    </section>
  );
}

/* ─── ROOT ──────────────────────────────────── */
export default function TeamPage() {
  useScrollReveal();
  return (
    <>
      <style>{CSS}</style>
      <div className="tm-wrap">
        <HeroSection />
        <TeamSection />
        <ProducerSection />
      </div>
    </>
  );
}